export const roles = {
  CUSTOMER: "CUSTOMER",
  CUSTOMER_CENTER: "CUSTOMER_CENTER",
  DIVISION_OR_BUSINESS_AREA: "DIVISION_OR_BUSINESS_AREA",
  FAILURE_ANALYSIS_ENGINEER: "FAILURE_ANALYSIS_ENGINEER",
  FAILURE_ANALYSIS_MANAGER: "FAILURE_ANALYSIS_MANAGER",
  PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM: "PRODUCT_COMPANY_TECHNICAL_SUPPORT_TEAM",
  QUALITY_MANAGER: "QUALITY_MANAGER",
  RECEIVING: "RECEIVING",
  SENIOR_FAILURE_ANALYSIS_ENGINEER: "SENIOR_FAILURE_ANALYSIS_ENGINEER",
  SERVICE_ENGINEER: "SERVICE_ENGINEER",
  SERVICE_TECHNICAL_SUPPORT_TEAM: "SERVICE_TECHNICAL_SUPPORT_TEAM",
  SERVICE_TECHNOLOGY_CENTER_MANAGER: "SERVICE_TECHNOLOGY_CENTER_MANAGER",
  SUPERADMIN: "SUPERADMIN",
  DISTRIBUTOR: "DISTRIBUTOR",
  CUSTOMER_CENTER_SERVICE_ENGINEER: 'CUSTOMER_CENTER_SERVICE_ENGINEER',
  SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER: 'SENIOR_CUSTOMER_CENTER_SERVICE_ENGINEER',
  ZONE_LEADER: 'ZONE_LEADER',
  QUESTION_ADMIN: 'QUESTION_ADMIN',
};



// WEBPACK FOOTER //
// ./src/constants/roles.js